import { useEffect } from 'react';
import AuthService from '../services/auth.service';

export default function ExtLogin() {
  const authService = AuthService.getInstance();

  useEffect(() => {
    window.location.href = `${authService.authAppUrl}/login`;
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Redirecting to login...</div>
    </div>
  );
}
